export default class OpportunityStatusChangeItem {
  constructor(item) {
    // item is the selected OpportunityItem row. OpportunityId feeds the status-transition
    // select (EntityId) and the save payload; ActualCloseOn drives the old-close-date warning.
    this.OpportunityId = item === undefined ? '' : item.OpportunityId;
    this.ActualCloseOn = item === undefined ? null : item.ActualCloseOn;
    this.Status = '';
    this.Comment = '';
    this.ReasonLostCode = '';
  }
}
